import createAdvancedSearchStorage from "../factory";

import advancedSearchSessionStorageProvider from "./provider";

const advancedSearchSessionStorage = createAdvancedSearchStorage(advancedSearchSessionStorageProvider);

export default advancedSearchSessionStorage;
